import React, { useEffect, useState } from 'react'

import { useSelector } from 'react-redux'

import useStyles from './searchlight-v2-style'

import ActionButton from '@components/action-button/action-button.component'
import BodyItem from '@components/body-item/body-item.component'
import CardDropdown from '@components/card-dropdown/card-dropdown.component'
import CardMap from '@components/card-map/card-map.component'
import CarouselContainer from '@components/carousel-container/carousel-container.component'
import UpdatedByContainer from '@components/updated-by-container/updated-by-container.component'

import { Badge, Card, Carousel, CardBody, CardHeader, Loader, CardMediaContainer, GUN_GRAY, Title, WHITE } from '@omnilert/components'

import { PRIORITY_FALSE_POSITIVE, PRIORITY_HEADER_GUN } from '../../assets/i18n/strings'

import axios from 'axios'

import i18n from 'i18n-js'

const SearchlightV2 = (props) => {
  const [updatedMedia, setUpdatedMedia] = useState([])
  const [isLoadingMedia, setIsLoadingMedia] = useState(true)

  const { message } = props

  const { collection, documentId } = message

  const document = useSelector(({ firestore: { data } }) => data[collection] && data[collection][documentId])

  const { actions, body, header, location, media, meta, updatedBy } = document

  const isFalsePositive = meta?.falsePositive

  const hasActions = !!actions?.data.length

  const hasMultipleActions = actions?.length > 1

  const variant = meta?.falsePositive ? 'invalid' : header?.data?.variant

  const titleColor = variant === 'invalid' ? GUN_GRAY : WHITE

  const classes = useStyles({ hasMultipleActions, variant })

  useEffect(() => {
    let retries = 0
    const maxRetries = 15
    const interval = 1000
    let requestTimeout
    const mediaWithBytes = media?.data?.map((obj) => ({
      ...obj,
      byteSize: 0
    }))

    const pingEndpoint = async () => {
      try {
        const url = mediaWithBytes[0].url || ''

        const response = await axios.head(url)

        const contentLength = response.headers['content-length']

        const byteSize = parseInt(contentLength)

        const cacheBusterUrls = mediaWithBytes.map((obj) => ({
          ...obj,
          byteSize,
          url: `${obj.url}?cacheBuster=${Date.now()}`
        }))

        clearInterval(requestTimeout)
        setUpdatedMedia(cacheBusterUrls)
        setIsLoadingMedia(false)
      } catch (error) {
        if (error.response === undefined) {
          clearInterval(requestTimeout)
          setUpdatedMedia(mediaWithBytes)
          setIsLoadingMedia(false)
          return
        }

        if (!requestTimeout) {
          requestTimeout = setInterval(pingEndpoint, interval)
        }

        retries++

        if (retries === maxRetries) {
          clearInterval(requestTimeout)
          setUpdatedMedia(mediaWithBytes)
          setIsLoadingMedia(false)
        }
      }
    }

    if (media?.data?.length > 0) {
      pingEndpoint()
    } else {
      setIsLoadingMedia(false)
    }
  }, [media?.data])

  if (!document) return null

  return (
    <Card className={classes.card}>
      {header &&
        <CardHeader
          className={classes.cardHeader}
          type={variant}
        >
          <Title
            className={classes.title}
            color={titleColor}
            size='sm'
          >{i18n.t(PRIORITY_HEADER_GUN)}
          </Title>
          <CardDropdown
            data={header?.data}
            direction='bottom'
          />
        </CardHeader>}

      {isFalsePositive &&
        <Badge
          className={classes.badge}
          type='error'
        >
          {i18n.t(PRIORITY_FALSE_POSITIVE)}
        </Badge>}

      {body &&
        <CardBody className={classes.cardBody}>
          {body.data.map((item, index) => <BodyItem
            key={index}
            item={item}
          />)}
        </CardBody>}

      {isLoadingMedia &&
        <Loader
          className={classes.loader}
          color={WHITE}
          size='lg'
        />}

      {!!updatedMedia.length && <CardMediaContainer media={updatedMedia} />}

      {location && <CardMap
        className={classes.map}
        locations={location?.data}
      />}

      {updatedBy && <UpdatedByContainer data={updatedBy.data} />}

      {hasActions && (
        <CarouselContainer>
          <Carousel
            className={classes.carousel}
            hideActions={isFalsePositive}
          >
            {actions.data.map(data => (
              <ActionButton
                key={`carouselItem-${data.id}`}
                data={data}
                documentId={documentId}
              />
            ))}
          </Carousel>
        </CarouselContainer>
      )}
    </Card>
  )
}

export default SearchlightV2
